import TableCorreiosDownload from "./TableCorreiosDownload";

export { default as TableDownload } from "./TableCorreiosDownload";
export default TableCorreiosDownload;
